import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useTranslation} from "react-i18next";
import {Field} from "redux-form";
import {TextInput} from "./TextInput";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import withStyles from "@material-ui/core/styles/withStyles";
import Box from "@material-ui/core/Box";
import {Typography} from "@material-ui/core";
import Divider from '@material-ui/core/Divider';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        flex: 1,
        paddingBottom: theme.spacing(2),
    },
    field: {
        paddingRight: theme.spacing(2)
    }

}));
const StyledIconButton = withStyles({
    root: {
        padding: '5px',
    },
})(IconButton);

const StyledAddIconButton = withStyles({
    root: {
        padding: '0 0 10px 0',
    },
})(IconButton);

const useGetDays = (fields) => {
    const {t} = useTranslation()
    const fieldsMap = fields.reduce((acc, value, index, arr) => {
        const day = arr.get(index).daysOfWeek[0]
        if (!acc[day]) {
            acc[day] = []
        }
        acc[day].push({value,index})
        return acc
    }, {})
    return [
        {
            number: 1,
            name: t('monday'),
            shifts: fieldsMap[1] || []
        },
        {
            number: 2,
            name: t('tuesday'),
            shifts: fieldsMap[2] || []
        },
        {
            number: 3,
            name: t('wednesday'),
            shifts: fieldsMap[3] || []
        },
        {
            number: 4,
            name: t('thursday'),
            shifts: fieldsMap[4] || []
        },
        {
            number: 5,
            name: t('friday'),
            shifts: fieldsMap[5] || []
        },
        {
            number: 6,
            name: t('saturday'),
            shifts: fieldsMap[6] || []
        },
        {
            number: 0,
            name: t('sunday'),
            shifts: fieldsMap[0] || []
        },
    ]
}

const SetBusinessHours = ({fields}) => {
    const classes = useStyles()
    const {t} = useTranslation()
    const days = useGetDays(fields)

    return <div className={classes.root}>
        {days.map(({number, name, shifts}) => {
            return <Box key={name}>
                <Typography variant={'h6'} gutterBottom={true} color={'primary'}>{name}</Typography>
                {shifts.map(({value,index}) => {
                    return <Box key={index} display={'flex'} pb={1}>
                        <Field name={`${value}.startTime`} type={'time'} component={TextInput}
                               label={t('start_time')}
                               className={classes.field} required/>
                        <Field name={`${value}.endTime`} type={'time'} component={TextInput} label={t('end_time')}
                               required/>
                        <StyledIconButton color='primary' onClick={() => fields.remove(index)}><DeleteIcon
                            size={'small'}/></StyledIconButton>
                    </Box>
                })}
                <StyledAddIconButton color='primary'
                            aria-label={t('add')}
                            onClick={() => fields.push({daysOfWeek: [number]})}><AddIcon/></StyledAddIconButton>
                <Divider color={'primary'} light={true} />
            </Box>
        })}
    </div>
}


export default SetBusinessHours;